import { Accordion as ChakraAccordion } from '@gazin/ecommerce-ui'
import React from 'react'
import { AccordionItem } from './accordionItem'

type AccordionProps = {
  children: React.ReactNode
  defaultIndex?: number[]
}

const AccordionComponent = ({
  children,
  defaultIndex = [0, 1, 2, 3, 4],
}: AccordionProps) => {
  return (
    <ChakraAccordion
      allowMultiple
      defaultIndex={defaultIndex}
      display="flex"
      flexDirection="column"
      rowGap="1rem"
      border={{ base: 'none', md: '0.0625rem solid #DCDDE3' }}
      borderRadius="0.5rem"
      padding="1rem"
      minW={{ base: '100%', md: '19.375rem' }}
    >
      {children}
    </ChakraAccordion>
  )
}

AccordionComponent.Item = AccordionItem

export const Accordion = AccordionComponent
